const TYPE = {
    ROUND : 'round',
    RECT : 'rect',
    ELLIPSE : "ellipse",
    TRIANGLE : "triangle",
    OCTAGON : "octa",
    HEX : "exa",
    IMAGE : "image",
    ROUNDED : "rounded"
}

export const DIRECTION = {
    LEFT : 'left',
    RIGHT : 'right',
    BOTTOM : 'bottom',
    TOP : 'top',
}

export default TYPE;